import { Provider } from "react-redux";
import "./App.css";
import AppRoute from "./routes/route";
import { store } from "./lib/features/store";
const App = () => {
  return (
    <Provider store={store}>
      <AppRoute />
    </Provider>
  );
};

export default App;
